<button class="btn-burger-menu" (click)="showBurgerMenu = !showBurgerMenu">
  <fa-icon [icon]="faBars"></fa-icon>
</button>

<nav class="main-nav-mobile" *ngIf="showBurgerMenu">
  <button
    class="btn-burger-menu-close"
    (click)="showBurgerMenu = !showBurgerMenu"
  >
    <fa-icon [icon]="faXmark"></fa-icon>
  </button>
  <a
    href="https://app.ubilaw.com"
    class="btn btn-primary btn-connect"
    target="_blank"
  >
    Connexion
  </a>
  <a routerLink="" fragment="benefices">Bénéfices</a>
  <a routerLink="" fragment="fonctionnalites">Fonctionnalités</a>
  <a routerLink="" fragment="pricing">Pricing</a>
  <a routerLink="" fragment="societe">Société</a>
</nav>
